var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "information-svgrepo-com") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dabas-Search-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-&-Explore---Filter---Labelling",
    transform: "translate(-176.000000, -258.000000)",
    fill: "#222222",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information-svgrepo-com",
    transform: "translate(176.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C3.5888,0 0,3.58884848 0,8.00004848 C0,12.4112485 3.5888,16 8,16 C12.4112,16 16,12.4112485 16,8.00004848 C16,3.58884848 12.4112,0 8,0 Z M8,14.5454545 C4.39078788,14.5454545 1.45454545,11.6092121 1.45454545,8.00004848 C1.45454545,4.39088485 4.39078788,1.45454545 8,1.45454545 C11.6092121,1.45454545 14.5454545,4.39088485 14.5454545,8.00004848 C14.5454545,11.6092121 11.6091636,14.5454545 8,14.5454545 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,3.55555556 C7.50985753,3.55555556 7.11111111,3.95448889 7.11111111,4.44484444 C7.11111111,4.93475556 7.50985753,5.33333333 8,5.33333333 C8.49014247,5.33333333 8.88888889,4.93475556 8.88888889,4.44484444 C8.88888889,3.95448889 8.49014247,3.55555556 8,3.55555556 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,6.22222222 C7.5090963,6.22222222 7.11111111,6.57045926 7.11111111,7 L7.11111111,11.6666667 C7.11111111,12.0962074 7.5090963,12.4444444 8,12.4444444 C8.4909037,12.4444444 8.88888889,12.0962074 8.88888889,11.6666667 L8.88888889,7 C8.88888889,6.57045926 8.4909037,6.22222222 8,6.22222222 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.e0b109b40ceb97bbd5f7402c5fa76b9b.svg";
export { ForwardRef as ReactComponent };